import * as React from "react";
import {useEffect} from "react";
import {apiMaintenance} from "../../services/Auth/maintenence";
import {Alert} from "@mui/lab";
import Snackbar from '@mui/material/Snackbar';
import {Grid} from "@mui/material";

export default function MaintenanceAdmin(props) {

    const {path} = props
    const vertical = 'bottom'
    const horizontal = 'center'

    const [maintenance, setMaintenance] = React.useState(false)
    const [comeBackTime, setComeBackTime] = React.useState("")

    useEffect(() => {
        apiMaintenance({}).then(resp => {
            setMaintenance(resp.data?.isActive)
            setComeBackTime(resp.data?.comeBackTime)
        }).catch(err => {
            setMaintenance(false)
            setComeBackTime("")
        })
    }, [path])

    return (
        <Snackbar
            anchorOrigin={{vertical, horizontal}}
            open={maintenance}
            variant="filled"
            key={vertical + horizontal}
        >
            <Alert severity="warning" style={{fontSize: 17, width: '100%'}} icon={false}>
                Maintenance mode is activated. <br/>Please come back later once this mode is disabled.<br/>
                {comeBackTime !== "" ? (<>Estimated time to resume service {comeBackTime}</>) : ''}
            </Alert>
        </Snackbar>
    )
}
